import { render, staticRenderFns } from "./MeetingClosureModuleNews.vue?vue&type=template&id=3da301f2&"
import script from "./MeetingClosureModuleNews.vue?vue&type=script&lang=js&"
export * from "./MeetingClosureModuleNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports